// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"572":"23508b98","672":"63375db3","712":"a2912b98"}[chunkId] + ".chunk.js";
};